import { z } from 'zod';

export const currencySchema = z.object({
  name: z.string(),
  rateToEur: z.string(),
});
export type Currency = z.infer<typeof currencySchema>;

export const priceSchema = z.object({
  validFrom: z.string(),
  validTo: z.string().nullable(),
  currency: currencySchema,
  vatRate: z.string(),
  priceMonthly: z.coerce.number(),
  priceAnnual: z.coerce.number(),
});
export type Price = z.infer<typeof priceSchema>;

export const productTypeSchema = z.object({
  name: z.string(),
  systemTypes: z.array(z.object({ id: z.number(), name: z.string() })),
  validFrom: z.string(),
  validTo: z.string().nullable(),
  dependencies: z.array(z.number()),
  description: z.string().optional(),
});
export type ProductType = z.infer<typeof productTypeSchema>;

export const variantSchema = z.object({
  id: z.number(),
  name: z.string(),
  productType: productTypeSchema,
  priceSet: z.array(priceSchema),
});
export type Variant = z.infer<typeof variantSchema>;

export const productSchema = z.object({
  id: z.number(),
  variant: z.number(),
  system: z.number(),
  status: z.enum(['pending', 'active', 'disabled']),
  billingContact: z.number(),
  billingFrequency: z.enum(['monthly', 'annual']),
});
export type Product = z.infer<typeof productSchema>;

export const createProductRequestSchema = z.object({
  variant: z.number(),
  system: z.number(),
  billingContact: z.number(),
  billingFrequency: z.enum(['monthly', 'annual']),
});
export type CreateProductRequest = z.infer<typeof createProductRequestSchema>;
